import { Box, Button, Checkbox, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectVehicleDetailsForm } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { VehicleDetailsFormValues } from "../../../types";
import {
  CHASSIS_DATA_FIELDS,
  VEHICLE_CONFIG_FIELDS,
  VEHICLE_DATA_FIELDS,
  VEHICLE_DETAILS_FORM_I18N_PREFIX,
  WEIGHT_DATA_FIELDS,
} from "../data";
import {
  FormFieldControl,
  FormSection,
  renderFieldControls,
} from "./FormControls";
import { useStyles } from "./styles";

const VehicleDetails = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const formValues = useSelector(selectVehicleDetailsForm);

  const updateField = (
    field: keyof VehicleDetailsFormValues,
    value: string | boolean
  ) => {
    dispatch(actions.updateVehicleDetailsFormField({ field, value }));
  };

  const formPrefix = VEHICLE_DETAILS_FORM_I18N_PREFIX;

  if (!formValues) {
    return null;
  }

  return (
    <>
      <FormSection titleKey={`${formPrefix}.SECTIONS.VEHICLE_DATA`} hideTopBorder>
        <Box className={styles.grid5v}>
          {renderFieldControls(VEHICLE_DATA_FIELDS, formValues, updateField)}
        </Box>
      </FormSection>

        <FormSection titleKey={`${formPrefix}.SECTIONS.VEHICLE_CONFIG`}>
          <Box className={styles.grid5}>
            {renderFieldControls(VEHICLE_CONFIG_FIELDS, formValues, updateField)}
          </Box>
        </FormSection>

        <FormSection titleKey={`${formPrefix}.SECTIONS.CHASSIS_DATA`}>
          <Box className={styles.row}>
            <Box className={styles.grid7}>
              {renderFieldControls(CHASSIS_DATA_FIELDS, formValues, updateField)}
            </Box>
            <Box className={styles.chassisActions}>
              <Typography className={styles.labelSpacer}>&nbsp;</Typography>
              <Box className={styles.chassisButtons}>
                <Button className={styles.btn} variant="outlined" color="primary">
                  {t(`${formPrefix}.BUTTONS.HEIGHT_TABLE`)}
                </Button>
                <Button className={styles.btn} variant="outlined" color="primary">
                  {t(`${formPrefix}.BUTTONS.ADD_HEIGHT`)}
                </Button>
              </Box>
            </Box>
          </Box>
        </FormSection>

        <FormSection titleKey={`${formPrefix}.SECTIONS.WEIGHT_DATA`}>
          <Box className={styles.grid5}>
            {renderFieldControls(WEIGHT_DATA_FIELDS, formValues, updateField)}
          </Box>
        </FormSection>

        <FormSection titleKey={`${formPrefix}.SECTIONS.ADDITIONS`}>
          <Box className={styles.additions}>
            <Box className={styles.additionsField}>
              <FormFieldControl
                config={{
                  field: "hydraulic",
                  labelKey: `${formPrefix}.FIELDS.HYDRAULIC`,
                  type: "select",
                  options: [["ALUM", `${formPrefix}.OPTIONS.HYDRAULIC`]],
                }}
                value={formValues.hydraulic}
                onChange={(value) => updateField("hydraulic", value)}
              />
            </Box>
            <Box className={styles.additionsField}>
              <Typography className={styles.labelSpacer}>&nbsp;</Typography>
              <Box className={styles.checkboxBox}>
                <Checkbox
                  size="small"
                  checked={formValues.transferBody}
                  onChange={(event) => updateField("transferBody", event.target.checked)}
                  sx={{ p: 0 }}
                />
                <Typography className={styles.fieldValue}>
                  {t(`${formPrefix}.FIELDS.TRANSFER_BODY`)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </FormSection>
    </>
  );
};

export default VehicleDetails;
